import { LoadingSkeleton } from "shared/components/molecules/LoadingSkeleton";

import { AuthorsLoadingSkeletonContainer } from "./styles";

interface IAuthorsLoadingSkeletonProps {
  contentLength: number;
}

export const AuthorsLoadingSkeleton = ({
  contentLength,
}: IAuthorsLoadingSkeletonProps) => {
  return (
    <AuthorsLoadingSkeletonContainer>
      {Array.from({ length: contentLength }, (_, i) => i + 1)?.map((item) => (
        <div key={`author-loading-skeleton-${item}`}>
          <div className="circle">
            <LoadingSkeleton.Circle size="165px" />
          </div>
          <LoadingSkeleton.Text width="70%" />
        </div>
      ))}
    </AuthorsLoadingSkeletonContainer>
  );
};
